import React from "react";
import { Tooltip } from "@material-ui/core";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudOffIcon from "@material-ui/icons/CloudOff";
import { css } from "@emotion/css";
import { RolloutStatus } from "../api";
import { Colors } from "../../../theme";

export const groupLabel = (group: string) => (group === "prod" ? "Prod" : group === "stage" ? "Stage" : group);

// Deployed = done (check). Deploying/undeploying are drawn as a matched pair — same cloud shape,
// opposite arrow direction and motion (in+rising vs out+sinking) — so the two transitional states
// read as opposites of each other rather than two unrelated glyphs.
const statusIcon = (status: RolloutStatus, stale: boolean) => {
  if (status === "active") {
    return <CloudDoneIcon fontSize="small" className={stale ? styles.staleIcon : styles.okIcon} />;
  }
  if (status === "activating") return <CloudUploadIcon fontSize="small" className={styles.pendingIcon} />;
  if (status === "unpublishing" || status === "retiring") {
    return <CloudDownloadIcon fontSize="small" className={styles.unpublishingIcon} />;
  }
  if (status === "retired") return <CloudOffIcon fontSize="small" className={styles.missingIcon} />;
  return <RemoveCircleOutlineIcon fontSize="small" className={styles.missingIcon} />;
};

const RolloutStatusChip: React.VFC<{
  status: RolloutStatus;
  label: string;
  tooltip: string;
  suffix?: string;
  stale?: boolean;
}> = ({ status, label, tooltip, suffix, stale = false }) => (
  <Tooltip title={tooltip}>
    <span className={`${styles.status} ${stale ? styles.staleText : ""}`}>
      {statusIcon(status, stale)} {label}
      {suffix ?? ""}
    </span>
  </Tooltip>
);

const styles = {
  status: css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.8125rem;
  `,
  staleIcon: css`
    color: ${Colors.WARNING_TEXT};
  `,
  staleText: css`
    color: ${Colors.WARNING_TEXT};
  `,
  okIcon: css`
    color: ${Colors.SUCCESS};
  `,
  missingIcon: css`
    color: ${Colors.DISABLED};
  `,
  unpublishingIcon: css`
    color: ${Colors.WARNING_TEXT};
    animation: sink-out 1.6s ease-in-out infinite;
    @keyframes sink-out {
      0%,
      100% {
        transform: translateY(0);
        opacity: 1;
      }
      50% {
        transform: translateY(3px);
        opacity: 0.35;
      }
    }
  `,
  pendingIcon: css`
    color: ${Colors.JA_BLUE};
    animation: rise-in 1.1s ease-in-out infinite;
    @keyframes rise-in {
      0%,
      100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-2px);
      }
    }
  `,
};

export default RolloutStatusChip;
